import React from "react";
// import LoadingOverlay from 'react-loading-overlay';
import {IAuthenticatedPageProps} from 'gui/components/authenticatedPage';
import styles from './Loader.module.scss';
import {ReactComponent as LoaderIcon} from 'assets/img/loader.svg';

interface ILoader extends IAuthenticatedPageProps {
  className?: any;
  loading?: boolean;
  loadingPlaceholder?: any;
  children?: any;
  spinner?: any;
  onClick?: any;
}


const Loader = (props: ILoader) => (
  props.loading ? props.loadingPlaceholder :
    <div
   //   active={props.loading}
      // spinner={<BounceLoader />}
    //  spinner={props.spinner}
   //   text={props.loadingPlaceholder}
      onClick={props.onClick}
      className={`${styles.loaderOverlay} ${props.className}`.trim()}
    >
      {props.children}
    </div>
);


Loader.defaultProps = {
  loading: false,
  loadingPlaceholder: null,
  children: null,
  spinner: <LoaderIcon/>,
  className: "",
};

export default Loader;
